import { IdoListSummaryEntry } from 'src/models/idoList';

import { Callback } from 'src/util/query/models/Callback';

import { IdoListCallbackStoreContract } from '../interfaces';

export class GetTheIdoListviewSummaryForAnInstanceQueryCallBack extends Callback<IdoListSummaryEntry[]> {
	public constructor(
		private readonly store: IdoListCallbackStoreContract,
		private readonly tabId: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setTabSummary({
			summary: [],
			tabId: this.tabId,
		});
		this.store.setTabSummaryLoading({
			isLoading: false,
			tabId: this.tabId,
		});
	};

	successCallbackFunction = (successResponse: IdoListSummaryEntry[]): void => {
		this.store.setTabSummary({
			summary: successResponse,
			tabId: this.tabId,
		});
		this.store.setTabSummaryLoading({
			isLoading: false,
			tabId: this.tabId,
		});
	};
}
